export const PAGE_ERROR_TYPES = ['error', 'permission', 'suspended', 'notFound', 'cached', 'unavailable'] as const;

export type PageErrorType = (typeof PAGE_ERROR_TYPES)[number];

type Metadata = {
  customMsg?: string;
  debug?: unknown;
};

export class PageError extends Error {
  name = 'PageError' as const;
  meta: Metadata | undefined;

  readonly type: PageErrorType;

  constructor(type: PageErrorType, meta?: Metadata) {
    super(`${type}`);

    this.type = type;
    this.meta = meta;
  }
}
